Object.defineProperty(exports, "__esModule", { value: true });
const signalRConnectionIdsCache_1 = require("../signalRConnectionIdsCache");
const tokenAuth_1 = require("../tokenAuth");
function generateHeaders(options) {
    const { action, headers } = options;
    const finalHeaders = new Headers();
    if (action !== 'Upload') {
        finalHeaders.set('Content-Type', 'application/json');
    }
    finalHeaders.set('Accept', 'application/json');
    if (!options.doNotUserBearerAuth) {
        const token = (0, tokenAuth_1.getAccessToken)();
        if (!!token) {
            finalHeaders.set('Authorization', 'Bearer ' + token);
        }
    }
    const usernameHashInput = document.getElementById('__UsernameHash');
    if (usernameHashInput) {
        finalHeaders.set('User', usernameHashInput.value);
    }
    const signalRConnectionIds = (0, signalRConnectionIdsCache_1.getAllConnectionIds)();
    if (signalRConnectionIds.length > 0) {
        finalHeaders.set('SignalRConnectionIds', signalRConnectionIds.join('|'));
    }
    if (headers) {
        headers.forEach((value, name) => {
            finalHeaders.set(name, value);
        });
    }
    return finalHeaders;
}
exports.default = generateHeaders;
//# sourceMappingURL=generateHeaders.js.map